import type { Lang } from '@/types/lang'
import { useGetQuoteQuery } from './studioApi'
import type { LanguageState } from './studioStartTypes'

export interface CourseLanguagesView {
  languages: LanguageState[]
  /** Базовый язык наполнен. Пока смета не доехала — `true`: точка — сигнал
   *  «что-то не так», и зажигать её по незнанию нельзя. */
  sourceFilled: boolean
  stateOf: (lang: Lang) => LanguageState | null
  refetch: () => void
  /** Смета перечитывается прямо сейчас. */
  isFetching: boolean
}

/**
 * Статусы языков курса (§6.1) — единственное место, где их читают шапка и
 * настройки. Считает СЕРВЕР по отпечаткам; своей копии правил в браузере нет.
 *
 * Та же смета, что у `useTranslationQuote`, — один кеш RTK Query. `refetch`
 * зовёт меню на открытии: спека обещает статусы «в момент открытия», а тег
 * `Quote` сам протухает только на терминальном статусе прогона.
 */
export const useCourseLanguages = (courseId: number, skip = false): CourseLanguagesView => {
  const { data, refetch, isFetching } = useGetQuoteQuery(courseId, { skip })
  const languages = data?.languages ?? []
  const source = languages.find((l) => l.is_source)
  return {
    languages,
    isFetching,
    sourceFilled: source?.filled ?? true,
    stateOf: (lang) => languages.find((l) => l.lang === lang) ?? null,
    // `refetch` у пропущенного запроса бросает — на закрытом диалоге нечего освежать.
    refetch: () => {
      if (!skip) void refetch()
    },
  }
}
